export const fetchGeneralInformation = () => {
  return [
    {
      question: "What is a Premier Seller?",
      answer:
        "A Premier Seller is a Business or a Sole Proprietor that acquires gift cards in quantity and then re-sells those gift cards to CardCash.  A Premier Seller is expected to sell $5,000.00 or more per month.",
    },
    {
      question: "What are the benefits of becoming a Premier Seller?",
      answer: `We reward our Premier Sellers with improved pricing so more profit is earned from the sale of your unwanted gift cards.  Premier Sellers can expect a 1-2% increase in rates for selling us gift cards in bulk.  We also offer: <br /><br />a) an easy-to-use system designed to sell gift cards in volume.<br />
      b) a Customer Success team to help you obtain quick answers to your questions.  <br />
      c) depending on the depth of our partnership, a dedicated Account Manager may be assigned to your account.`,
    },
    {
      question: "What is compliance? And why do I need this?",
      answer:
        "Compliance is a formal process that all Premier Sellers must fulfill.  This includes verification of your business, business owners, bank account information, and risk processes.",
    },
  ];
};

export const fetchSellingGiftCards = () => {
  return [
    {
      question: "How do I enter gift cards into your system?",
      answer: `There are 3 ways that a Premier Seller can enter gift cards into our system.<br /><br />
  
        1. Manual entry.  Begin typing the brand name into the ‘Brand Name’ field and select the appropriate brand.  Continue entering all required gift card information and select ‘Add to Order.’  <br />
        2. Upload Spreadsheet.  The instructions are <a href="/spreadsheet-instructions">here</a>. <br />
        3. Magstripe Swiping.  CardCash provides a magnetic stripe swiper to all Premier Sellers.  Simply swipe the gift card and the brand name and gift card number will be populated.  Don’t have a magnetic stripe swiper?  Please contact your account manager or <a href="mailto:customersuccess@cardcash.com">customersuccess@cardcash.com</a> to request one.`,
    },
    {
      question: "What does “This card is ineligible for sale’ mean?",
      answer: `This result can mean a few things.  <br /><br />
      1. Either you or another CardCash customer has sold us this card before. <br />
      2. We have elected to block this gift card or a range of gift card numbers that includes this gift card number.
      `,
    },
  ];
};

export const fetchMerchantInformation = () => {
  return [
    {
      question: "What brands do you accept?",
      answer: `Our list of accepted brands and their rates can be found  <a href="/current-rates">here</a>. `,
    },
    {
      question: "What does Online vs Mail-In mean?",
      answer: `Mail-in requires that you must mail in the gift card to CardCash for processing. Online means that you are not required to mail in the gift card for processing.`,
    },
    {
      question: "Do you accept Merchandise Credit?",
      answer: `Yes we do accept some merchandise credits, but not all.  Our list of accepted brands can be found <a href="/current-rates">here</a>.  To search for the brand you’re looking to sell, simply type in the brand name in the search field and our list will narrow down to help you find your answer. `,
    },
    {
      question: "I have a gift card brand that you don’t carry.  What do I do?",
      answer: `CardCash is constantly adding brands to our catalog.  If you don’t see the brand you’re trying to sell, please send a brief note to <a href="mailto:customersuccess@cardcash.com">customersuccess@cardcash.com</a> with the brand name.  CardCash will evaluate the brand to determine if it meets our acceptance criteria. `,
    },
    {
      question:
        "What are the minimum and maximum values accepted for each brand?",
      answer: ` In most cases, the minimum value of a gift card accepted is $1.00. Some merchants, however, are higher than that. For nearly all brands, our maximum value accepted is $500.00. Categories such as restaurants, fast food, and fast-fashion clothing are usually less. Please check your <a href="/current-rates">rates</a> for further details on min and max values.`,
    },
  ];
};

export const fetchOrdersAndPayments = () => {
  return [
    {
      question: "How long does it take to process my order?",
      answer: `Orders are typically processed within two business days of receiving the gift cards (either physically or electronically) unless there are unusual circumstances with one or many gift cards.  `,
    },
    {
      question: "How fast do I get paid?",
      answer: `We believe getting payments to you fast is important for your business.  If your order is processed by 11 a.m. EST on any business day, we’ll initiate the payment to you that day.  Depending on your approved method of payment (e.g. ACH or PayPal), we expect your payment to be received within 1-2 business days from the date we initiate the payment.  `,
    },
    {
      question: "Why was my order canceled?",
      answer: `The most common reason for order cancellation is the gift card(s) in the order had a $0.00 balance or could not be verified.  If this is not the case, I recommend you contact your account manager for more information.  `,
    },
    {
      question: "How do I add or update a bank account to receive payments?",
      answer: `Changing your bank account is an easy process.  Email <a href="mailto:compliance@cardcash.com">compliance@cardcash.com</a> requesting to add or update a bank account.  Remember to always include your Account Manager in the email as well.  `,
    },
    {
      question:
        "My bank account information is no longer available.  I only see PayPal as a payment option.  What do I do?",
      answer: `Chances are you’ve reset the password to your account. As a security measure on all password resets, we hide your bank account information. <br /><br />You have two options.  <br /><br />1. Re-enter your bank account information by selecting Payment Methods and Add Account. Enter your bank account information and the payment option should appear. If this does not work then you have option  <br /><br/>2. Contact your account manager or email <a href="mailto:customersuccess@cardcash.com">customersuccess@cardcash.com</a>  for assistance.`,
    },
  ];
};

export const fetchBadCardsLiabilitiesAndDeductions = () => {
  return [
    {
      question: "What is a bad card?",
      answer: `In CardCash terms, any card that has had a balance shift or the gift card has been turned off by the merchant is considered a ‘bad card.’`,
    },
    {
      question: "What is a deduction?",
      answer: `When you sell a gift card to CardCash, you are liable for that gift card through the entire liability period.  If at any time during the liability period, the balance shifts or the merchant has turned off the gift card, you are responsible for paying that value back.  CardCash will create a liability against your account and deduct your account balance.  `,
    },
    {
      question: "Can I view my liabilities?",
      answer: `Yes. The Liabilities screen displays the outstanding balance owed to CardCash for bad cards and provides greater details as to why a card has had problems.`,
    },
  ];
};
